(function () {
	if (window.__tnsVideoSound) return;
	window.__tnsVideoSound = true;

	const VIDEO_SCOPE =
		".media-banner__content, .hero-video, .editorial-video-text__media-wrap, .split-editorial__media";

	const isUnmuted = (button) => button.classList.contains("active");
	const isPaused = (button) => button.classList.contains("active");

	const setSoundState = (button, unmuted) => {
		if (!button) return;
		button.classList.toggle("active", unmuted);
		button.setAttribute("aria-pressed", unmuted ? "true" : "false");
	};

	const setPlayState = (button, paused) => {
		if (!button) return;
		button.classList.toggle("active", paused);
		button.setAttribute("aria-pressed", paused ? "true" : "false");
	};

	const isDisplayed = (el) => {
		const wrap = el.closest(".media-banner__video");
		if (!wrap) return true;
		return window.getComputedStyle(wrap).display !== "none";
	};

	const getMedia = (button) => {
		const scope = button.closest(VIDEO_SCOPE);
		if (!scope) return {};
		const videos = Array.from(scope.querySelectorAll("video"));
		const iframes = Array.from(scope.querySelectorAll("iframe"));
		return {
			video: videos.find(isDisplayed) || null,
			iframe: iframes.find(isDisplayed) || null,
			soundButton: scope.querySelector(".js-sound-video"),
			playButton: scope.querySelector(".js-play-video"),
		};
	};

	const setExternalSound = (iframe, unmuted) => {
		if (!iframe) return;

		if (iframe.classList.contains("js-youtube")) {
			iframe.contentWindow.postMessage(
				JSON.stringify({
					event: "command",
					func: unmuted ? "unMute" : "mute",
					args: "",
				}),
				"*"
			);
			iframe.classList.toggle("video-muted", !unmuted);
			return;
		}

		if (iframe.classList.contains("js-vimeo")) {
			iframe.contentWindow.postMessage(
				JSON.stringify({
					method: "setVolume",
					value: unmuted ? 1 : 0,
				}),
				"*"
			);
			iframe.classList.toggle("video-muted", !unmuted);
		}
	};

	const setExternalPlayback = (iframe, play) => {
		if (!iframe) return;

		if (iframe.classList.contains("js-youtube")) {
			iframe.contentWindow.postMessage(
				JSON.stringify({
					event: "command",
					func: play ? "playVideo" : "pauseVideo",
					args: "",
				}),
				"*"
			);
			iframe.classList.toggle("video-pause", !play);
			iframe.classList.toggle("video-play", play);
			return;
		}

		if (iframe.classList.contains("js-vimeo")) {
			iframe.contentWindow.postMessage(
				JSON.stringify({
					method: play ? "play" : "pause",
				}),
				"*"
			);
			iframe.classList.toggle("video-pause", !play);
			iframe.classList.toggle("video-play", play);
		}
	};

	const setMuted = (button, muted) => {
		const { video, iframe, playButton } = getMedia(button);

		if (video) {
			video.muted = muted;
			if (!muted && video.paused) {
				video.play().catch(() => {});
				setPlayState(playButton, false);
			}
		}

		setExternalSound(iframe, !muted);
		setSoundState(button, !muted);
	};

	const setPaused = (button, paused) => {
		const { video, iframe } = getMedia(button);

		if (video) {
			if (paused) {
				video.pause();
			} else {
				video.play().catch(() => {});
			}
		}

		setExternalPlayback(iframe, !paused);
		button.dataset.userPaused = paused ? "true" : "false";
		setPlayState(button, paused);
	};

	const muteOthers = (activeButton) => {
		document.querySelectorAll(".js-sound-video").forEach((button) => {
			if (button === activeButton || !isUnmuted(button)) return;
			setMuted(button, true);
		});
	};

	const syncNativePlayback = (scope) => {
		const playButton = scope.querySelector(".js-play-video");
		if (!playButton) return;

		scope.querySelectorAll("video").forEach((video) => {
			if (video.dataset.tnsPlaySync) return;
			video.dataset.tnsPlaySync = "true";
			const sync = () => {
				if (!isDisplayed(video)) return;
				if (playButton.dataset.userPaused === "true") {
					setPlayState(playButton, true);
					return;
				}
				setPlayState(playButton, video.paused);
			};
			video.addEventListener("play", sync);
			video.addEventListener("pause", sync);
		});
	};

	const initPlaybackSync = () => {
		document.querySelectorAll(VIDEO_SCOPE).forEach((scope) => {
			if (scope.querySelector(".js-play-video")) syncNativePlayback(scope);
		});
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initPlaybackSync);
	} else {
		initPlaybackSync();
	}
	document.addEventListener("shopify:section:load", initPlaybackSync);

	document.addEventListener("click", (event) => {
		const playButton = event.target.closest(".js-play-video");
		if (playButton) {
			event.preventDefault();
			event.stopPropagation();
			setPaused(playButton, !isPaused(playButton));
			return;
		}

		const soundButton = event.target.closest(".js-sound-video");
		if (!soundButton) return;

		event.preventDefault();
		event.stopPropagation();

		const unmuted = !isUnmuted(soundButton);
		if (unmuted) muteOthers(soundButton);
		setMuted(soundButton, !unmuted);
	});
})();
